import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/auth-1.jpg")